import axios from 'axios'
import store from '@/store'
import { REQUEST_URL } from '@/config'
import cryptoJS from 'crypto-js'
import { Toast } from 'vant'
import { getUrlParams } from '@/utils'
import router from '../router'
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'

const request = axios.create({
  baseURL: REQUEST_URL,
  timeout: 20000,
})

request.interceptors.request.use(
  async (config) => {
    store.dispatch('isShowLoading', true)
    config.headers['Authorization'] = getUrlParams('token') || ''
    // config.headers['Authorization'] =
    //   'eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiIwMGVmY2Y0ZmUwNTI0NzRjOTRhODUzNDI2OTFkODkzMCIsImp0aSI6ImRhNzY3MWRkLWViZmUtNDI1Ni1hZDdlLWI3YzFhNzY4NmNhMSJ9.NdiohOoTL0ZpXyvOyAmO1WevfGM6TSsPSD_7qLJkMmS5hWlkwoKTDkfMWsQNMWZLYdsEgqgRu0YI_mQPt3kqCg' ||
    //   ''
    const date = new Date().getTime()
    config.headers['sign'] = cryptoJS
      .MD5('Khaos-hc-2020%^$*&#' + date + config.url)
      .toString()
      .toUpperCase()
    config.headers['invokeTime'] = date
    console.log(config)
    return config
  },
  (error) => {
    Promise.reject(error)
  },
)

request.interceptors.response.use(
  async (response) => {
    store.dispatch('isShowLoading', false)
    const res = response.data
    if (res.code === 200) {
      return res.data || res.message
    } else if (res.code === 251) {
      router.replace('/notFound')
      return
    } else {
      if (res.code === 100 || res.code === 400) {
        // debugger
        Toast(res.message)
        return
      }
      return Promise.reject(res.message)
    }
  },
  (error) => {
    store.dispatch('isShowLoading', false)
    console.log(error)
    if (error.response) {
      // switch (error.response.status) {
      //   case 401:
      //     //返回401，清除token信息并跳转到登录
      //     removeStore('HC_POPAWS_H5_TOKEN').then((res) => {
      //       Toast('账号已失效请联系管理员')
      //       router.replace('/login')
      //     })
      //     break
      // }
    }
    if (`${error}`.indexOf('timeout') > 0) {
      Toast('网络链接超时，请稍后重试')
    } else if (`${error}`.indexOf('Network') > 0) {
      Toast('网络异常，请稍后重试')
    } else if (`${error}`.indexOf('Request failed with status') > 0) {
      Toast('服务器异常，请稍后重试')
    } else {
      Toast(error)
    }
    return Promise.reject(error)
  },
)

export default request
